import { borderVariables, textVariables } from '@sylveraio/tailwind'

import type { BorderOptions, ScaleOptions } from 'chart.js'

export const DEFAULT_BORDER_OPTIONS: Partial<BorderOptions> = {
  display: false,
  dash: [3, 4],
}

export const DEFAULT_GRID_OPTIONS: ScaleOptions['grid'] = {
  drawTicks: false,
  tickBorderDash: [3, 4],
  color: borderVariables['default'],
}

export const DEFAULT_TICK_OPTIONS: ScaleOptions['ticks'] = {
  font: {
    size: 12,
    weight: 400,
  },
  color: textVariables['subtle'],
  padding: 6,
}

export const DEFAULT_TITLE_OPTIONS: ScaleOptions<'linear'>['title'] = {
  font: {
    size: 14,
    weight: 400,
  },
  color: textVariables['subtle'],
}

export const TIME_SERIES_SCALE_GRID_OPTIONS: ScaleOptions['grid'] = {
  offset: false,
  drawTicks: true,
}

export const TIME_SERIES_SCALE_TICKS_OPTIONS: ScaleOptions['ticks'] = {
  align: 'start',
  includeBounds: true,
}

export const TIME_SERIES_SCALE_TIME_OPTIONS: ScaleOptions<'time'>['time'] = {
  tooltipFormat: 'd MMMM yyyy',
}
